/**
 * Prevent the default event behavior
 * @param {object} e - event object
 * @returns {boolean}
 */
export default function preventDefault(e) {
    e.preventDefault();
    if (e.nativeEvent) {
        e.nativeEvent.preventDefault();
    }
    return false;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/prevent-default.js